export const baseUrl = process.env.GATSBY_BASE_API ??
  "https://bhfcp21qw9.execute-api.us-east-2.amazonaws.com/dev";
